<template>
  <loading :loading="loading">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <h4 class="title">
          Novo Chamado
        </h4>
        <p class="category">
          Preencha os campos
        </p>
      </md-card-header>

      <md-card-content class="md-layout">
        <md-field
          v-if="!isBB"
          class="md-layout-item md-size-100"
        >
          <label>MODALIDADE</label>
          <md-select
            id="modality"
            v-model="selectedModality"
            name="modality"
            @md-selected="filterCategories()"
          >
            <md-option
              v-for="modality in modalityOptions"
              :key="modality.id"
              :value="modality.id"
            >
              {{ modality.name }}
            </md-option>
          </md-select>
        </md-field>

        <md-field class="md-layout-item md-size-100">
          <label>CATEGORIA</label>
          <md-select
            id="category"
            v-model="selectedCategory"
            name="category"
          >
            <md-option
              v-for="category in categoriesToShow"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </md-option>
          </md-select>
        </md-field>

        <md-field
          v-if="selectedModality === 5"
          class="md-layout-item md-size-100"
        >
          <label>PRIORIDADE</label>
          <md-select
            id="urgency"
            v-model="selectedUrgency"
            name="urgency"
          >
            <md-option
              v-for="urgency in urgencyOptions"
              :key="urgency.id"
              :value="urgency.id"
            >
              {{ urgency.name }}
            </md-option>
          </md-select>
        </md-field>

        <md-field class="md-layout-item md-size-100">
          <label>TIPO DE EQUIPAMENTO</label>
          <md-select
            id="equipmentType"
            v-model="selectedEquipmentType"
            name="equipmentType"
            @md-selected="onEquipmentTypeChange"
          >
            <md-option
              v-for="equipmentType in equipmentModels"
              :key="equipmentType.itemtype"
              :value="equipmentType.itemtype"
            >
              {{ equipmentType.name }}
            </md-option>
          </md-select>
        </md-field>

        <md-field
          v-if="equipmentsChoices && equipmentsChoices.length"
          class="md-layout-item md-size-100"
        >
          <label>EQUIPAMENTO</label>
          <md-select
            id="equipment"
            v-model="selectedEquipment"
            name="equipment"
          >
            <md-option
              v-for="equipment in equipmentsChoices"
              :key="equipment.glpiid"
              :value="equipment.glpiid"
            >
              {{ equipment.name }} {{ equipment.tag }}
            </md-option>
          </md-select>
        </md-field>

        <md-field class="md-layout-item md-size-100">
          <label>DESCRIÇÃO</label>
          <md-textarea v-model="ticketDescription" />
        </md-field>

        <div class="md-layout-item md-size-100 text-right">
          <md-button
            class="md-raised md-success"
            @click="createTicket()"
          >
            ADICIONAR CHAMADO
          </md-button>
        </div>
      </md-card-content>
    </md-card>
  </loading>
</template>

<script>
import {userService} from "../../_services";
import {getUserSession} from "../../_services/localstorage";
import Loading from "../../components/Loading";
import {DateTime} from "luxon";

const MODALITY_LOOKUP = [
  "Instalação",
  "Comissionamento",
  "Manutenção Preventiva",
  "Suporte Técnico",
  "Manutenção Corretiva",
  "Auditoria",
  "As-Built",
  "Start-Up",
  "Treinamento",
  "Consultoria",
  "Manutenção Preditiva",
  "Manutenção Corretiva Programada",
  "Evolutiva",
  "TI",
];

export default {
  name: "NewTicketForm",
  components: {
    Loading,
  },
  equipment: String,
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    },
    allCategories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      user: null,

      ticketDescription: null,
      selectedEquipmentType: null,
      selectedEquipment: null,
      selectedModality: 0,
      selectedUrgency: 2,
      selectedCategory: 0,

      categoriesToShow: [],
      modalityOptions: [],
      urgencyOptions: [],
      equipmentModels: [],
      equipmentsChoices: null,
    };
  },
  computed: {
    isBB() {
      return this.user.activeentity === 595;
    },
  },
  watch: {
    async allCategories() {
      await this.retrieveAllCategories();
    }
  },
  async created() {
    this.returnUrl = "/activities";

    this.user = getUserSession();

    // Update Variables
    this.modalityOptions = this.user.modalityOptions;
    this.urgencyOptions = this.user.urgencyOptions;
    this.equipmentModels = this.user.equipmentModels;
    this.typeOption = this.user.typeOption;
    this.statusOption = this.user.statusOption;

    // Treating Customization by Customer
    this.selectedModality = 3;

    await this.retrieveAllCategories();

    this.loading = false;
  },
  methods: {
    async retrieveAllCategories() {
      // When BB
      if (this.isBB) {
        const { list: categories } = await userService.searchItilCategories(this.user.token, "DCIM");
        this.categoriesToShow = categories;
        this.selectedEquipmentType = "Printer";
        return;
      }

      const isCategoryRoot = category => category.parent === null;
      const isCategoryRequest = category => category.request === 1;
      const isCategoryIncident = category => category.incident === 1;

      this.categoryList = this.allCategories
        .filter(isCategoryRoot)
        .filter(isCategoryRequest)
        .filter(isCategoryIncident);

      this.filterCategories();
    },
    async createTicket() {
      if (this.selectedModality === 0) {
        return;
      }

      let ticketType = 2;
      // Confirmation that the Urgency is Low
      if (this.selectedModality !== 5) {
        this.selectedUrgency = 2;
      } else {
        ticketType = 1;
      }

      // Check that the customer does not open a ticket that is alocated to someone
      const status = 1;

      //Get Equipment Name and TAG
      let equipmentName = "";
      if (this.equipmentsChoices && this.selectedEquipment) {
        const selectedEquipment = this.equipmentsChoices.find(choice => choice.glpiid === this.selectedEquipment);
        equipmentName = `${selectedEquipment.name} ${selectedEquipment.tag}`;
      }

      //Get Category Name
      let categoryName = "";
      if (this.categoriesToShow && this.selectedCategory) {
        categoryName = this.categoriesToShow.find(category => category.id === this.selectedCategory).name;
      }

      const now = DateTime.now();
      let title = [
        MODALITY_LOOKUP[this.selectedModality - 1].toUpperCase(),
        equipmentName,
        now.toFormat("dd/MM/yyyy"),
      ].join(" - ");

      if (this.ticketDescription == null) {
        this.ticketDescription = title;
      }

      if (this.isBB && categoryName) {
        title = `${categoryName.toUpperCase()} - ${equipmentName} - DCIM BB`;
      }

      const { data: createdTicket } = await userService.addTicket(
        this.user.token,
        title,
        this.ticketDescription,
        this.selectedModality,
        this.selectedUrgency,
        status,
        ticketType,
        this.selectedCategory,
      );

      if (this.selectedEquipment) {
        await userService.relateAssetToTicket(this.user.token, this.selectedEquipmentType, this.selectedEquipment, createdTicket.id);
      }

      this.$router.push(this.returnUrl);

    },
    async onEquipmentTypeChange() {
      if (this.selectedEquipmentType === null) {
        return;
      }

      if (this.equipmentModelSelectionOld === this.selectedEquipmentType) {
        return;
      }

      this.loading = true;

      this.equipmentModelSelectionOld = this.selectedEquipmentType;
      this.equipmentsChoices = await userService.getAllActives(this.user.token, this.selectedEquipmentType);

      this.loading = false;
    },
    filterCategories() {
      if (!this.categoryList) {
        return;
      }

      // Ignore BB
      if (this.isBB) {
        return;
      }

      if (this.selectedModality === this.oldModality) {
        return;
      }

      this.oldModality = this.selectedModality;
      let filter = [];

      switch (this.selectedModality) {
        case 1:
          // Modality Instalation
          filter = ["Energia"];
          break;
        case 3:
          // Modality Preventive
          filter = ["Energia", "Clima", "Automação"];
          break;
        case 4:
          // Modality Support
          filter = ["Energia", "Clima", "Incêndio"];
          break;
        case 5:
          // Modality Corrective
          filter = ["Energia", "Clima", "Incêndio", "Civil", "Automação"];
          break;
        case 14:
          // Modality Corrective
          filter = ["Cabling"];
          break;
      }

      const isCategoryOnFilter = category => filter.includes(category.name);

      this.categoriesToShow = this.categoryList.filter(isCategoryOnFilter);
    },
  }
};
</script>

<style>
/*noinspection CssUnusedSymbol*/
.md-list-item-text {
  justify-content: center;
  padding-left: 20px;
}
</style>
